import { Box, Grid, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useTenantFormContext } from '../tenant-form-context'
import DegreedSwitchInput from './degreed-switch-input'
import { FeatureFormContext } from './feature-form-context'
import WeeklyEmailSwitchInput from './weekly-email-switch-input'
import EmailReportSchedulerSwitchInput from './email-report-scheduler'
import { useStyles } from './style'
import PlaylistsSettings from './playlists'
import XapiSettings from './xapi'
import { IntegrationSettings } from './integration'
import { StackOneSettings } from './stackone'
import CornerstoneSettings from './cornerstone'
import MindsetSettings from './mindset-ai'
import MyLearningSettings from './my-learning'
import { HelixMigrationSettings } from './helix-migration-switch-input'
import CommentsSettings from './comments'
import LpqSettings from './lpq'

const Features = () => {
  const classes = useStyles()
  const { spacing } = useTheme()
  const { tenant, mainClasses } = useTenantFormContext()

  return (
    <FeatureFormContext.Provider value={{ tenant }}>
      <Grid container className={classes.root}>
        <Grid container alignItems='center' className={mainClasses.ctnTitle}>
          <Grid item xs={9}>
            <Typography variant='h6'>Features</Typography>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Box display='flex' justifyContent='space-between' style={{ paddingRight: spacing(3) }}>
            <Box>
              <Typography variant='caption' color='textSecondary'>
                Define the features will be available to this Toolkit
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <WeeklyEmailSwitchInput />
        </Grid>
        <Grid item xs={12}>
          <EmailReportSchedulerSwitchInput />
        </Grid>
        <Grid item xs={12}>
          <CommentsSettings />
        </Grid>
        <Grid item xs={12}>
          <PlaylistsSettings />
        </Grid>
        <Grid item xs={12}>
          <DegreedSwitchInput />
        </Grid>
        <Grid item xs={12}>
          <XapiSettings />
        </Grid>
        <Grid item xs={12}>
          <IntegrationSettings />
        </Grid>
        <Grid item xs={12}>
          <StackOneSettings />
        </Grid>
        <Grid item xs={12}>
          <CornerstoneSettings />
        </Grid>
        <Grid item xs={12}>
          <HelixMigrationSettings />
        </Grid>
        <Grid item xs={12}>
          <MindsetSettings />
        </Grid>
        <Grid item xs={12}>
          <MyLearningSettings />
        </Grid>
        <Grid item xs={12}>
          <LpqSettings />
        </Grid>
      </Grid>
    </FeatureFormContext.Provider>
  )
}

export default Features
